import isEmptyArrayOrObject from './is-empty-array-or-object.js';
import isUndefined from './is-undefined.js';
import { isBlankString } from './strings.js';
function isEmptyValue(value) {
    if (typeof value === 'object' && value !== null) {
        return isEmptyArrayOrObject(value);
    }
    if (typeof value === 'string') {
        return isBlankString(value);
    }
    return isUndefined(value) || value === null;
}
export default isEmptyValue;
//# sourceMappingURL=is-empty-value.js.map